import React from "react";
import style from "./ActionBar.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import { cancelMultipleApp, deleteBulkApps } from "../../../../../api";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import CrossIcon from "../../../../assets/svg/icons/common/CrossIcon";
import Trash from "../../../../assets/svg/icons/common/Trash";
import toast from "react-hot-toast";
import ChangeOwner from "../ChangeOwner/ChangeOwner";
import useApplicationStore from "../../../../stores/application";
import useCommonStore from "../../../../stores/common";

function ActionBar({ selectedApps, close, fetchList }) {
  const setActiveApp = useApplicationStore((state) => state.setActiveApp);
  const setShowAppDetails = useCommonStore((state) => state.setShowAppDetails);

  const [showConfirmationModal, setShowConfirmationModal] =
    React.useState(false);
  const [showConfirmDeleteModal, setShowConformDeleteModal] =
    React.useState(false);
  const [showChangeOwnerModal, setShowChangeOwnerModal] = React.useState(false);

  const cancelApps = async () => {
    const toastID = toast.loading("Cancelling apps...");
    const response = await cancelMultipleApp({ ids: selectedApps });
    if (response.status) {
      toast.success("Apps cancelled successfully", { id: toastID });
      close();
      fetchList();
      setShowAppDetails(false);
      setActiveApp(null);
    } else {
      toast.error("Something went wrong", { id: toastID });
    }
  };

  const deleteApps = async () => {
    const toastID = toast.loading("Deleting apps...");

    const response = await deleteBulkApps({ bulkDeleteIds: selectedApps });
    if (response.status) {
      toast.success("Apps deleted successfully", { id: toastID });
      fetchList();
      close();
      setShowAppDetails(false);
      setActiveApp(null);
    } else {
      toast.error("Something went wrong", { id: toastID });
    }
  };

  return (
    <>
      <div className={style.action_bar}>
        <span className={style.prefix}>{selectedApps.length} selected:</span>
        <div className={style.actions}>
          <ButtonIcon
            bgColor={"#28272d00"}
            textColor="#FFF"
            onClick={() => setShowChangeOwnerModal(true)}
          >
            Change Owner
          </ButtonIcon>
          <ButtonIcon
            bgColor={"#28272d00"}
            textColor="#FFF"
            onClick={() => setShowConfirmationModal(true)}
          >
            Cancel Apps
          </ButtonIcon>
          <ButtonIcon
            bgColor={"#28272d00"}
            textColor="#FFF"
            onClick={() => setShowConformDeleteModal(true)}
          >
            <Trash />
            <span>Delete Apps</span>
          </ButtonIcon>
          <ButtonIcon bgColor={"#28272d00"} textColor="#FFF" onClick={close}>
            <CrossIcon />
          </ButtonIcon>
        </div>
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          open={showConfirmationModal}
          onClose={() => setShowConfirmationModal(false)}
          message={
            "Are you sure you want to cancel the selected apps? You can’t undo this action."
          }
          onConfirmClick={() => cancelApps()}
        />
      )}

      {showConfirmDeleteModal && (
        <ConfirmationModal
          open={showConfirmDeleteModal}
          onClose={() => setShowConformDeleteModal(false)}
          message={
            "Are you sure you want to delete the selected apps? You can’t undo this action."
          }
          onConfirmClick={() => deleteApps()}
        />
      )}

      {showChangeOwnerModal && (
        <ChangeOwner
          open={showChangeOwnerModal}
          onClose={() => setShowChangeOwnerModal(false)}
          selectedApps={selectedApps}
          bulkAction={true}
          bulkActionProps={{
            fetchList: fetchList,
            close: close,
          }}
        />
      )}
    </>
  );
}

export default ActionBar;
